/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatRegular from './chat-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatRegular {...validProps} />;
}
SvgComponent.iconName = 'chat-regular';

export const ChatRegularIcon = svgIconWrapper(SvgComponent);
